/**
 * Emits Core Telemetry events using only the default UTel fields.
 */ export var CoreTelemetryWorkload = /*#__PURE__*/ function(CoreTelemetryWorkload) {
    CoreTelemetryWorkload["PlannerWeb"] = "Planner Web";
    CoreTelemetryWorkload["Teams"] = "Teams";
    CoreTelemetryWorkload["Outlook"] = "Outlook";
    CoreTelemetryWorkload["SharePoint"] = "SharePoint";
    CoreTelemetryWorkload["Loop"] = "Loop";
    CoreTelemetryWorkload["Other"] = "Other";
    return CoreTelemetryWorkload;
}({});
export var CoreTelemetrySubWorkload = /*#__PURE__*/ function(CoreTelemetrySubWorkload) {
    CoreTelemetrySubWorkload["Planner"] = "Planner";
    CoreTelemetrySubWorkload["ChannelsTab"] = "ChannelsTab";
    CoreTelemetrySubWorkload["TaskFromMessage"] = "TaskFromMessage";
    CoreTelemetrySubWorkload["SharePointPlannerWebPart"] = "SharePointPlannerWebPart";
    CoreTelemetrySubWorkload["TaskListComponent"] = "Task List Component";
    CoreTelemetrySubWorkload["Other"] = "Other";
    return CoreTelemetrySubWorkload;
}({});
export var CoreTelemetryLicenseType = /*#__PURE__*/ function(CoreTelemetryLicenseType) {
    CoreTelemetryLicenseType["None"] = "None";
    CoreTelemetryLicenseType["ReadOnlyPremium"] = "ReadOnlyPremium";
    CoreTelemetryLicenseType["P1"] = "P1";
    CoreTelemetryLicenseType["P3"] = "P3";
    CoreTelemetryLicenseType["P5"] = "P5";
    return CoreTelemetryLicenseType;
}({});
